<template>
  <transition name="fade" mode="out-in">
    <div class="body" v-if="show">
      <div id="lottie" ref="animationContainer">
      </div>
      <div class="text-dark text-h5 relative-position loader-text">
        لحظة البيانات تّحمل...
      </div>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { useLottie } from '@/composables/useLottie';
import animationData from '@/assets/images/animate/akwad_loader.json';

defineProps<{
  show: boolean;
}>();

const { animationContainer } = useLottie(animationData);
</script>

<style scoped>
.body {
  background-color: #ffffff;
  margin: 0px;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 999999999999999999999999999999999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

#lottie {
  background-color: #ffffff;
  width: 12%;
  height: 12%;
  display: block;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  text-align: center;
  opacity: 1;
}

.loader-text {
  top: 15px;
}

@media screen and (max-width: 1024px) {
  #lottie {
    width: 12%;
    height: 16%;
  }
}

@media screen and (max-width: 768px) {
  #lottie {
    width: 30%;
    height: 16%;
  }
}
</style>
